import { BrowserRouter } from 'react-router-dom';
import { Routes } from './routes';
import { ThemeProvider } from '@/providers/ThemeProvider';
import { StoreProvider } from '@/providers/StoreProvider';
import { TanstackQueryProvider } from '@/providers/TanstackQueryProvider';


function App() {
  return (
    <StoreProvider>
      <TanstackQueryProvider>
          <BrowserRouter>
            <ThemeProvider defaultTheme="dark" storageKey="ui-theme">
              <Routes />
            </ThemeProvider>
          </BrowserRouter>
      </TanstackQueryProvider>
    </StoreProvider>
  );
}

export default App;
